import { FC } from 'react';

interface LoaderProps {
  className?: string;
  children?: React.ReactNode;
}
const Loader: FC<LoaderProps> = ({ className = '', children }) => {
  return (
    <div className={`loader ${className}`}>
      <div className="content">
        {children}
      </div>
      <div className="lds-flickr">
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
  );
}

export default Loader;
